import palette from '../palette';

const overrides = (theme) => ({
  input: {
    '&::placeholder': {
      opacity: 1,
      color: palette.text.secondary,
    },
  },
});
export default overrides;
